import { useState } from "react";
import { Toggle } from "../shared";

const POPULAR_CHAINS = [
  { id: "ethereum", name: "Ethereum", symbol: "ETH" },
  { id: "base", name: "Base", symbol: "ETH" },
  { id: "polygon", name: "Polygon", symbol: "MATIC" },
  { id: "bsc", name: "BNB Chain", symbol: "BNB" },
  { id: "arbitrum", name: "Arbitrum", symbol: "ETH" },
  { id: "avalanche", name: "Avalanche", symbol: "AVAX" },
];

const MORE_CHAINS = [
  { id: "telos", name: "Telos", symbol: "TLOS" },
  { id: "chiliz", name: "Chiliz", symbol: "CHZ" },
  { id: "flare", name: "Flare", symbol: "FLR" },
  { id: "hemi", name: "Hemi", symbol: "ETH" },
  { id: "soneium", name: "Soneium", symbol: "SON" },
  { id: "bitlayer", name: "Bitlayer", symbol: "BTC" },
  { id: "matchain", name: "Matchain", symbol: "MAT" },
  { id: "bitfinity", name: "Bitfinity", symbol: "BFT" },
];

function ChainRow({ chain, isOn, onToggle, disabled }) {
  return (
    <div className="mcp-chain-item">
      <div className="mcp-chain-info">
        <span
          className={`mcp-chain-dot ${isOn ? "mcp-dot-green" : "mcp-dot-gray"}`}
        />
        <span className="mcp-chain-name">{chain.name}</span>
        <span className="mcp-chain-symbol">{chain.symbol}</span>
      </div>
      <Toggle
        checked={isOn}
        onChange={() => onToggle(chain.id)}
        disabled={disabled}
      />
    </div>
  );
}

export default function ChainToggles({ allowedChains, onToggle, disabled }) {
  const [showMore, setShowMore] = useState(false);

  return (
    <div
      className={`mcp-chain-toggles ${disabled ? "mcp-disabled-section" : ""}`}
    >
      <h5 className="mcp-subsection-title">Allowed chains</h5>
      <div className="mcp-chain-grid">
        {POPULAR_CHAINS.map((chain) => (
          <ChainRow
            key={chain.id}
            chain={chain}
            isOn={allowedChains?.includes(chain.id)}
            onToggle={onToggle}
            disabled={disabled}
          />
        ))}
      </div>

      {/* Collapsible extra chains */}
      <button
        type="button"
        className="mcp-show-more-btn"
        onClick={() => setShowMore(!showMore)}
      >
        {showMore ? "Show fewer \u25b4" : `Show more \u25be (${MORE_CHAINS.length})`}
      </button>

      {showMore && (
        <div className="mcp-chain-grid">
          {MORE_CHAINS.map((chain) => (
            <ChainRow
              key={chain.id}
              chain={chain}
              isOn={allowedChains?.includes(chain.id)}
              onToggle={onToggle}
              disabled={disabled}
            />
          ))}
        </div>
      )}
    </div>
  );
}
